const fragment = `
  id
  urlPattern
  matchType
  createdAt
  lastVisitedAt
  visitsCount
  entityType
  communityId
  community {
    id
    name
  }
  modelId
  model {
    id
    name
  }
  projectId
  project {
    id
    name
  }
  buildingModelId
  buildingModel {
    id
    name
  }
`;

export const listTrackingPagesQuery = `
  query ListTrackingPages(
    $filter: TrackingPageFilterInput
  ) {
    items: listTrackingPages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getTrackingPageQuery = `
  query GetTrackingPage($id: Int!) {
    item: getTrackingPage(id: $id) {
      ${fragment}
    }
  }
`;

export const createTrackingPageMutation = `
  mutation CreateTrackingPage(
    $input: CreateTrackingPageInput!
  ) {
    item: createTrackingPage(input: $input) {
      ${fragment}
    }
  }
`;

export const updateTrackingPageMutation = `
  mutation UpdateTrackingPage(
    $input: UpdateTrackingPageInput!
  ) {
    item: updateTrackingPage(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteTrackingPageMutation = `
  mutation DeleteTrackingPage($id: Int!) {
    item: deleteTrackingPage(id: $id) {
      ${fragment}
    }
  }
`;
